import React from 'react';

import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { SelectInfoProvider } from './selectInfo';

const AppProvider: React.FC = ({ children }) => {
  return (
    <SelectInfoProvider>
      <AuthProvider>
        <ToastProvider>{children}</ToastProvider>
      </AuthProvider>
    </SelectInfoProvider>
  );
};

export default AppProvider;
